import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import { useSelector } from 'react-redux';
import { _t } from 'utils';
import moment from 'moment';
import Shared from 'screens/shared';
import EditForm from 'screens/nlb/single/forwarding-rule/create';
import { ROUTE, FORWARDING_RULE_ALGORITHM } from 'constant';
import { ACTIONS_TYPES } from 'redux/helper';

export const NLBForwardingRule = ({ history, match }) => {
  const { dcId, nlbId, id } = match.params;
  const { [ACTIONS_TYPES.NETWORK_LOAD_BALANCER.GET_FORWARDING_RULE]: forwardingRule = {} } = useSelector((e) => e);
  const { properties = {}, metadata = {} } = forwardingRule;

  useEffect(() => {
    actions.networkLoadbalancer.getForwardingRule({ dcId, id: nlbId, forwardingRuleId: id });
  }, [dcId, nlbId, id]);

  const propertiesRows = [
    ['Name', properties?.name],
    ['Target IP', properties?.listenerIp],
    ['Listener Port', properties?.listenerPort],
    ['Protocol', properties?.protocol],
    ['Algorithm', (FORWARDING_RULE_ALGORITHM[properties?.algorithm] || {}).label],
    [_t('Last Updated'), moment(metadata?.lastModifiedDate).fromNow()],
  ];

  const deleteHandler = () => {
    actions.networkLoadbalancer.deleteForwardingRule({ dcId, forwardingRuleId: id, id: nlbId });
    history.goBack();
  };

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.NLB_FORWARDING_RULE}
      strapIcon="angle-double-right"
      strapTitle={properties?.name}
      editForm={<EditForm item={{ id, ...properties }} {...{ dcId, nlbId, ips: [] }} />}
      editAction={ACTIONS_TYPES.NETWORK_LOAD_BALANCER.UPDATE_FORWARDING_RULE}
      onDelete={deleteHandler}
    >
      <Shared.widgets.Properties properties={propertiesRows} />
      <Shared.widgets.Section
        className="-m-t-24"
        sectionTitle="Targets"
        items={properties?.targets}
        itemIcon="bullseye"
        setItemTitle={(e) => e?.ip}
        setItemDetails={(e) => (
          <div>
            <span>{`Port: ${e?.port}`}</span>
            <span style={{ color: 'lightgray' }}> | </span>
            <span>{`Weight: ${e?.weight}`}</span>
          </div>
        )}
      />
    </Shared.widgets.Page>
  );
};
